import React, { useEffect, useState, useRef } from "react";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {
  DataGrid,
  GridColDef,
  GridActionsCellItem,
  GridValueGetterParams,
  GridToolbar,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarColumnsButton,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import DetailsIcon from "@mui/icons-material/Details";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import ShowerIcon from "@mui/icons-material/Shower";
import { FxmsData } from "../../datas/FxData";
import { FxAction } from "./../../actions/FxAction";
import { FxFileLink } from "./../../inputs/FxFileLink";
import { FxPopup } from "../../windows/FxPopup";
import { OpClass } from "./../../datas/OpClass";
import { FxRenderer } from "../../datas/FxRenderer";
import { FxmsPopup, FxPopupOpener } from "../../windows/FxWindows";
import { FxResource } from "../../inputs/FxResource";
import { exportRowsToExcel } from '../../../vup/common/commonMethod';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import "./FxDataGrid.css";

/**
 * FxDataGrid
 * 데이터 그리드
 *
 * 개발자 : T/F팀.
 * 개발년월 : 2022.11.
 * @param {*} props
 * @returns
 */

export function FxDataGrid(props) {
  const { attrList, rows, onClickRow, height, menuFullName } = props;
  const [selectedData, setSelectedData] = React.useState([]);
  const [selectedDataId, setSelectedDataId] = React.useState([]);
  const columns = makeColumns(attrList, onClickIcon, false);
  const popupCols = getPopupColumn(attrList);
  const openRef = React.useRef(new Array(popupCols.length));

  const [selectedRow, setSelectedRow] = React.useState([]);
  const [contextMenuXy, setContextMenuXy] = React.useState(null,
    {
      mouseX: 0,
      mouseY: 0
    });
  const [modalOpen, setModalOpen] = useState(false);
  const [opObj, setOpObj] = useState([]);

  /*context메뉴 관련 기능*/
  const handleContextMenu = (event) => {
    event.preventDefault();
    setSelectedRow(event.currentTarget.getAttribute('data-id'));    
    const obj = FxmsData.getOpObj(attrList[0].opId + '-detail') ;
    if(obj !== undefined){
      setContextMenuXy(
        contextMenuXy === null
          ? { mouseX: event.clientX - 2, mouseY: event.clientY - 4 }
          : null,
      );
      setOpObj(obj);
    }
  };
  const handleClose = () => {
    setContextMenuXy(null);
  };

  const closeModal = () => {
    setModalOpen(false);
  }

  const contextMenu = () => {
    const row= rows.filter((row) => {
      if (row.id.toString() === selectedRow.toString()) {
          return row;
      }
    });

     //const row = rows[selectedRow];

    setSelectedRow(row[0]);   
    handleClose();
    setModalOpen(true);

  };
  /*context메뉴 관련 기능 끝*/

  function onClickIcon(attr, selectedDataId, selectedData) {

    if (attr.linkOpObj.opTypeCd === "UI") {
      setSelectedData(selectedData);
      setSelectedDataId(selectedDataId);
      openRef.current[attr.popupIndex]();
    } else {
      new FxAction(attr, selectedData, selectedDataId).execute(function (data) {
        // if (refreshCall) refreshCall(data);
      });
    }
  }

  useEffect(() => {
    RenderDatas.init(attrList);
  }, [attrList]);

  // 처음이면 선택된 내용이 없음을 알린다.
  useEffect(() => {
    if (onClickRow) {
      onClickRow(null);
      handleClose();
    }
  }, [rows]);

  // 데이터가 선택되면 선택됨을 알린다.
  const handleRowClick = (params) => {
    if (onClickRow) {
      onClickRow(params);
      setSelectedRow(params.row);
    }
  };

  // function CustomToolbar() {
  //   return (
  //     <GridToolbarContainer sx={{float: "right"}}>
  //       <GridToolbarExport
  //         csvOptions={{
  //           utf8WithBom: true,
  //           includeHeaders: true,
  //         }}
  //         printOptions={{ disableToolbarButton: true }}
  //       />
  //     </GridToolbarContainer>
  //   );
  // }

  // 엑셀 다운로드 함수
  const exportToExcel = () => {
    exportRowsToExcel({
      columns,
      rows,
      fileName: menuFullName || "tableData",
      sheetName: (menuFullName || "downloadData").replaceAll("/", "_"),
      excludeId: true
    });
  };

  // 커스텀 툴바
  const CustomToolbar = () => {
    return (
      <div className="excelDown">
          <Button onClick={exportToExcel} startIcon={<FileDownloadIcon />}>
            엑셀 다운로드
          </Button>
        </div>
    );
  };

  return (
    <>
      <Box className="DataGridList">
        <DataGrid
          components={{ Toolbar: CustomToolbar }}
          localeText={{
            toolbarExport: "엑셀 다운로드",
          }}
          className="DataGrid"
          cellClassName="DataGridCell"
          headerClassName="DataGridHeader"
          rows={rows}
          rowHeight={36}
          columns={columns}
          checkboxSelection={false}
          experimentalFeatures={{ newEditingApi: true }}
          onRowClick={handleRowClick}
          componentsProps={{
            row: {
              onContextMenu: handleContextMenu,
              style: { cursor: 'context-menu' },
            },
          }}
          sx={{height: height}}
        // sx={{fontSize: '13pt', fontWeight: '200'}}
        // pageSize={100}
        // rowsPerPageOptions={[5]}
        // disableSelectionOnClick
        />

      <Menu
        open={contextMenuXy !== null}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={
          contextMenuXy !== null
            ? { top: contextMenuXy.mouseY, left: contextMenuXy.mouseX }
            : undefined
        }
        componentsProps={{
          root: {
            onContextMenu: (e) => {
              e.preventDefault();
              handleClose();
            },
          },
        }}
      >
      <MenuItem onClick={contextMenu} style={{'color' : "white"}}>상세보기</MenuItem>

      </Menu>
      </Box>

      <FxmsPopup open={modalOpen} closeModal={closeModal} dialogTitle={opObj.opTitle} opObj={opObj}>
       <FxResource menu={opObj} selectedData={selectedRow} selectedDataId={selectedDataId} onCloseBtnClick={closeModal} refershGridData= {attrList.callback}/>
      </FxmsPopup>

      {popupCols.length > 0
        ? popupCols.map((attr, i) => {
          return (
            <FxPopup
              open={true}
              key={attr.attrName}
              openRef={openRef}
              title={attr.linkOpObj.opTitle}
              refIndex={i}
              opObj={attr.linkOpObj}
              selectedData={selectedData}
              selectedDataId={selectedDataId}
            />
          );
        })
        : ""}
    </>
  );
}



/**
 * 목록 상세보기
 * 개발자 : T/F팀
 * 개발년월 : 2022.11
 *
 * @param {*} props
 * @returns
 */
export function FxDataGridAuto(props) {
  const { menu, paraData, paraId } = props;
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const style = {
    height: "600px",
    width: menu.uiWidth === 0 ? "100%" : menu.uiWidth + "px",
  };

  useEffect(() => {
    RenderDatas.init(menu.attrList);
    let opClass = OpClass.getOpClass(menu.opId);
    setColumns(makeColumns(menu.attrList, null, true));

    const inputData = {};

    const [
      attrList,
      toolbarAttrList,
      gridAttrList,
      sortAttr,
      initOpClass,
      idAttrList,
    ] = opClass.getAttrInfo();


    let callOp;
    for (const attr of attrList) {
      if (attr.attrTypeCd === "button" && attr.attrDftVal === "select") {
        callOp = FxmsData.getOpObj(attr.linkOpId);
      } else {
        if (attr.attrDftVal) {
          inputData[attr.attrName] = attr.attrDftVal;
        } else if (paraData[attr.attrName]) {
          inputData[attr.attrName] = paraData[attr.attrName];
        }
      }
    }

    console.log("*** FxDataGridAuto ***", menu.opId, callOp.opUri, inputData, sortAttr);

    // 조회 결과를 넘긴다.
    FxmsData.selectGridData(
      callOp.opUri,
      inputData,
      sortAttr.attrName,
      sortAttr.attrTypeCd
    ).then(function (res) {
      checkRowDatas(res.data, idAttrList);
      setRows(res.data);
    });

  }, []);

  return (
    <>
      <Box className="DataGridList" sx={{ height: "600px", width: "100%" }}>
        <DataGrid
          className="DataGrid"
          cellClassName="DataGridCell"
          headerClassName="DataGridHeader"
          rows={rows}
          columns={columns}
          rowHeight={32}
          // pageSize={100}
          // rowsPerPageOptions={[5]}
          checkboxSelection={false}
          // disableSelectionOnClick
          experimentalFeatures={{ newEditingApi: true }}
        />
      </Box>
    </>
  );
}
/**
 * 그리드 컬럼을 생성한다.
 * @param {Array} attrList
 * @param {Boolean} onlyData
 * @returns
 */
export function makeColumns(attrList, onClickIcon, onlyData = false) {
  const columns = [];

  function checkCss(column, attr) {
    const etcInfoObj = attr.etcInfoObj;

    if (etcInfoObj) {
      if (etcInfoObj.className) {
        if (typeof etcInfoObj.className === "string") {
          column.cellClassName = etcInfoObj.className;
        } else if (typeof etcInfoObj.className === "object") {
          column.cellClassName = function (params) {
            // 매칭
            const ret = etcInfoObj.className[params.row[attr.attrName]];
            if (ret) {
              return ret;
            }

            // 값 없으면
            if (
              etcInfoObj.className.isEmpty &&
              FxmsData.isEmpty(params.row[attr.attrName])
            ) {
              return etcInfoObj.className.isEmpty;
            }

            // 값이 있으면
            if (
              etcInfoObj.className.hasValue &&
              FxmsData.isEmpty(params.row[attr.attrName]) === false
            ) {
              return etcInfoObj.className.hasValue;
            }

            return "";
          };
        }
      }
    }
  }

  for (let attr of attrList) {
    if (attr.attrGrp !== "grid") {
      continue;
    }
    if (onlyData && attr.attrTypeCd === "button") {
      continue;
    }

    let column = {
      field: attr.attrName,
      headerName: attr.attrUiTxt,
      width: attr.uiWidth,
      headerClassName: "DataGridHeader",
      editable: false,
      type: "string",
    };

    if (attr.attrTypeCd === "button" || attr.attrTypeCd === "icon") {
      const linkOp = FxmsData.getOpObj(attr.linkOpId);
      if (linkOp === null || linkOp === undefined) {
        continue;
      }

      column.headerName = "";
      column.type = "actions";
      column.width = attr.attrTypeCd === "icon" ? 24 : attr.uiWidth;
      column.renderCell = function (params) {
        return (
          // <strong>
          <DataGridButton
            attr={attr}
            params={params}
            opObj={linkOp}
            onClick={onClickIcon}
          />
          // </strong>
        );
      };
    } else if (attr.attrTypeCd === "datetime" || attr.attrTypeCd === "date") {
      column.valueGetter = (params) => FxRenderer.renderDate(params.row[attr.attrName]);
    } else if (attr.attrTypeCd === "select") {
      column.valueGetter = function (params) {
        return RenderDatas.getText(attr, params.row[attr.attrName]);
      };
    } else if (attr.attrTypeCd === "number") {
      column.type = "number";
    } else if (attr.attrTypeCd === "filelink") {
      column.type = "actions";
      column.width = attr.attrTypeCd === "filelink" ? 300 : attr.uiWidth;
      column.renderCell = function (params) {
        // const fileInfo = JSON.parse(attr.attrValList);
        // const fileInfoKey = params.row[fileInfo.fileKey] + "";
        // return (
        //   <FxFileLink
        //     fileKey={fileInfoKey}
        //     fileUrl={fileInfo.fileUrl}
        //   ></FxFileLink>
        // );

        //const fileInfo = JSON.parse(attr.attrValList);
        //const fileInfoKey = params.row[fileInfo.fileKey] + "";

        return (
          <FxFileLink
            orgNm={params.row.orgNm}
            fileId={params.row.fileId}
          ></FxFileLink>
        );
      };
    }

    checkCss(column, attr);
    columns.push(column);
  }

  console.log("*** makeColumns ***", columns);

  return columns;
}

/**
 * 그리드 컬럼에 포함되는 버튼
 * @param {} props
 * @returns
 */
const DataGridButton = (props) => {
  const { attr, opObj, params } = props;

  const onClick = React.useCallback((data) => () => {
    if (props.onClick) props.onClick(attr, data.id, data.row);
  });

  if (attr.attrTypeCd === "icon") {
    return (
      <>
        <Tooltip title={opObj.opTypeCd + "," + attr.attrUiTxt}>
          <IconButton onClick={onClick(params)}>
            {opObj.opTypeCd === "DELETE" ? (
              <DeleteIcon sx={{ "& :hover": { color: "#00d1ff" } }} />
            ) : opObj.opTypeCd === "UPDATE" ? (
              <ChangeCircleIcon />
            ) : opObj.opTypeCd === "UI" && opObj.uiCmptName === "CRUD-EDIT" ? (
              <ChangeCircleIcon sx={{ "& :hover": { color: "#00d1ff" } }} />
            ) : opObj.opTypeCd === "UI" && opObj.uiCmptName === "CRUD-SHOW" ? (
              <ShowerIcon />
            ) : (
              <DetailsIcon />
            )}
          </IconButton>
        </Tooltip>
      </>
    );
  } else {
    return (
      <>
        <Button
          variant="contained"
          // variant="outlined"
          size="small"
          // style={{ margin: 1, padding:2 }}
          // tabIndex={params.hasFocus ? 0 : -1}
          onClick={onClick(params)}
          className="DataGridButton"
        >
          {attr.attrUiTxt}
        </Button>
      </>
    );
  }
};


/**
 * GRID 컬럼에서 POPUP을 띄어야 하는 내용 검색
 * @param {*} attrList
 * @returns
 */
function getPopupColumn(attrList) {
  const ret = [];
  let index = 0;
  for (let attr of attrList) {
    if (attr.attrGrp !== "grid") {
      continue;
    }
    if (attr.attrTypeCd === "button" || attr.attrTypeCd === "icon") {
      const linkOp = FxmsData.getOpObj(attr.linkOpId);
      if (linkOp === null || linkOp === undefined) {
        continue;
      }
      attr.popupIndex = index++;
      ret.push(attr);
    }
  }
  return ret;
}

/**
 * 그리드에 등록할 때 필요한 id를 생성한다.
 * 개발자 : T/F팀
 * 개발년월 : 2022.12
 * @param {*} datas
 * @param {*} keyIndexAttrList
 * @returns
 */
export function checkRowDatas(datas, keyIndexAttrList) {

  /**
   * 데이터 그리드에 넣기 위해 ID를 가져온다.
   * @param {*} data
   * @returns
   */
  function getId(data) {
    if (data.id) return data.id;

    let ret = undefined;
    for (const attr of keyIndexAttrList) {
      if (ret === undefined) {
        ret = data[attr.attrName];
      } else {
        ret += ",";
        ret += data[attr.attrName];
      }
    }
    return ret;
  }


  let idIdx = 0;

  for (const data of datas) {
    const newId = getId(data);
    if (newId) {
      data.id = newId;
    } else if (data.id === undefined) {
      data.id = idIdx++;
    }
  }

  return datas;
}


class RenderDatas {

  static renderMap = new Map();

  static init(attrList) {
    for (let attr of attrList) {
      if (attr.attrTypeCd === "select") {
        RenderDatas.loadMap(attr);
      }
    }
  }

  static getMap(attr) {
    const map = RenderDatas.renderMap.get(attr.attrValList);
    if (map) return map;
    RenderDatas.loadMap(attr);
  }

  static getText(attr, key) {
    const map = RenderDatas.getMap(attr);
    if (map === null || map === undefined) {
      return "(코드)" + key;
    }
    try {
      const text = map.get(key.toString());
      return text ? text : "(코드)" + key;
    } catch (error) {
      console.log(error);
      return "(코드)" + key;
    }
  }

  static setMap(attr, map) {
    RenderDatas.renderMap.set(attr.attrValList, map);
  }

  static async loadMap(attr) {
    const para = JSON.parse(attr.attrValList);
    const type = para.type;
    // 파라메터의 type을 backend로 넘기지 않는다.
    delete para.type;

    const map = new Map();
    RenderDatas.setMap(attr, map);

    const list = await FxmsData.getSelectItemRt(type, para);
    for (let data of list) {
      map.set(data.key.toString(), data.text);
    }
    return map;
  }
}











/**
 * 기본 데이터 그리드
 * 개발자 : T/F팀
 * 개발년월 : 2023.03
 *
 * @param {List} columns 그리드 컬럼
 * @param {List} rows 그리드 데이터
 * @param {function} onCellSelected 셀 선택되면 호출 function(selectedRow)
 * @param {string} height 그리드 높이
 * @returns
 */
export function FxDataGridBase(props) {

  const { columns, rows, onCellSelected } = props;
  const height = props.height ? props.height : "480px";

  // 데이터가 선택되면 선택됨을 알린다.
  const onRowClick = (params) => {
    if (onCellSelected) {
      onCellSelected(params.row)
    } else {
      console.log("selected grid row but not defined function.")
    }
  };

  // TODO : 페이지를 보일지 말지 외부에서 결정

  return (
    <Box className="DataGridList" sx={{ height: height, width: "100%" }}>
      <DataGrid
        className="DataGrid"
        cellClassName="DataGridCell"
        headerClassName="DataGridHeader"
        rows={rows}
        columns={columns}
        rowHeight={32}
        // pageSize={100}
        // rowsPerPageOptions={[5]}
        checkboxSelection={false}
        // disableSelectionOnClick
        onRowClick={onRowClick}
        enablePagination={false}
        experimentalFeatures={{ newEditingApi: true }}
      />
    </Box>
  );
}